import axios from "axios";


const apiUrl = process.env.REACT_APP_API_URL;

const token = localStorage.getItem("accessToken");

const deletePrivateUser = async (privateUserId: number) => {
    try {
        const response = await axios.delete(`${apiUrl}/PrivateUser/deletePrivateUser`, {
            params: { privateUserId },
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error: any) {
        throw new Error(`Error deleting private user: ${error.message}`);
    }
}

export default deletePrivateUser;